import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";
import { pdf } from "@react-pdf/renderer";
import FeesStructurePDF12 from "./FeesStructurePdf12";
import CryptoJS from "crypto-js";
import { decryptConfig } from "../../UI/Decrypt";

function FeesStructure12() {
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isPreviewed, setIsPreviewed] = useState(false);
  const navigate = useNavigate();
  const token = sessionStorage.getItem("intermediateaccountstoken");
  const [class12DeveloperMode, setClass12DeveloperMode] = useState("");

  const SECRET_KEY = config.SECRET_KEY;
  function generateOneTimeToken() {
    const timestamp = Date.now();
    const nonce = CryptoJS.lib.WordArray.random(16).toString();
    const payload = `${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(payload, SECRET_KEY).toString();

    return `${timestamp}:${nonce}:${signature}`;
  }

  useEffect(() => {
    const fetchConfigData = async () => {
      try {
        const tokeng = generateOneTimeToken();
        const response = await fetch(
          `${config.API_BASE_URL}/FetchConfigurationData`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-Private-Key": tokeng,
            },
          }
        );

        const data = await response.json();
        if (response.ok) {
          const configData =  decryptConfig(data?.data);
          setClass12DeveloperMode(configData.cL_12_DEVELOPER_MODE);
        } else {
          Swal.fire("Error", data.message || "Invalid response", "error");
        }
      } catch (error) {
        Swal.fire("Error", "Something went wrong. Try again later.", "error");
      }
    };

    fetchConfigData();
  }, []);
  // Fetch Data
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${config.API_BASE_URL2}/FetchFeesStructure_CL12`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch data");

      const data = await response.json();
      setTableData(data.data?.feesStructureDataCL12_list || []);
    } catch (error) {
      console.error("Error fetching table data:", error);
      Swal.fire("Error", "Unable to load fees structure data.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    document.body.classList.add("sidebar-icon-only");
    return () => {
      document.body.classList.remove("sidebar-icon-only");
    };
  }, []);

  const sendEmail = async () => {
    try {
      const tokeng = generateOneTimeToken();
      const pdfBlob = await pdf(
        <FeesStructurePDF12 tableData={tableData} />
      ).toBlob();
      const pdfFile = new File([pdfBlob], "Class-XII-Fees-Structure.pdf", {
        type: "application/pdf",
      });

      // 1st Email
      const formData1 = new FormData();
      if (class12DeveloperMode === "NO") {
        formData1.append("To", "itcell.jac@gmail.com");
        formData1.append("Bcc", "parikshadata@gmail.com");
      } else {
        formData1.append("To", "sounak@cludotechnology.in");
        formData1.append("Bcc", "parikshadata@gmail.com");
      }
      formData1.append(
        "Subject",
        "ANNUAL INTERMEDIATE EXAMINATION 2026 FEES STRUCTURE"
      );
      formData1.append(
        "Message",
        "ANNUAL INTERMEDIATE EXAMINATION 2026 FEES STRUCTURE"
      );
      formData1.append("Attachments", pdfFile);

      const response1 = await fetch(`${config.API_BASE_URL2}/SendMail1`, {
        method: "POST",
        headers: {
          // "Content-Type": "application/json",
          "X-Private-Key": tokeng,
        },
        body: formData1,
      });

      const data1 = await response1.json();

      if (!(response1.ok && (data1.success || data1.status === "ok"))) {
        Swal.fire("Error", data1.message || "Failed to send email.", "error");
        return false;
      }
      // const tokengg = generateOneTimeToken();
      // const formData2 = new FormData();
      // if (class12DeveloperMode === "NO") {
      //   formData2.append("To", "parikshadata@gmail.com");
      // } else {
      //   formData2.append("To", "baidyanathdas@cludotechnology.in");
      // }
      // formData2.append("Subject", "Updated Fees Structure - CLASS XII");
      // formData2.append(
      //   "Message",
      //   "Please find attached the updated Class XII Fees Structure PDF."
      // );
      // formData2.append("Attachments", pdfFile);

      // const response2 = await fetch(`${config.API_BASE_URL2}/SendMail1`, {
      //   method: "POST",
      //   headers: {
      //     // "Content-Type": "application/json",
      //     "X-Private-Key": tokengg,
      //   },
      //   body: formData2,
      // });

      // const data2 = await response2.json();

      // if (!(response2.ok && (data2.success || data2.status === "ok"))) {
      //   Swal.fire(
      //     "Error",
      //     data2.message || "Failed to send 2nd email.",
      //     "error"
      //   );
      //   return false;
      // }
    } catch (error) {
      console.error("Error sending email:", error.message);
      Swal.fire("Error", error.message || "Something went wrong", "error");
      return false;
    }
  };

  // Input Change Handler
  const handleInputChange = (e, key, index) => {
    const value = e.target.value;

    // Allow only numbers and 2 decimal places
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;

    const newData = [...tableData];
    newData[index][key] = value;

    const toNum = (val) => parseFloat(val) || 0;

    const odppm = toNum(newData[index].odppM_FEE);
    const exam = toNum(newData[index].exaM_FEE);
    const pc = toNum(newData[index].pC_FEE);
    const msfct = toNum(newData[index].m_S_FEE_F_C_T);
    const mig = toNum(newData[index].miG_FEE);
    const localLevy = toNum(newData[index].locaL_LEVY);
    const misc = toNum(newData[index].misC_FEE);
    const reReg = toNum(newData[index].rE_REG_FEE);
    const late = toNum(newData[index].latE_FEE);

    const beforeLateTotal = +(
      odppm +
      exam +
      pc +
      msfct +
      mig +
      localLevy +
      misc +
      reReg
    ).toFixed(2);
    const afterLateTotal = +(beforeLateTotal + late).toFixed(2);

    newData[index].beforE_LATE_TOTAL_FEE = beforeLateTotal;
    newData[index].afteR_LATE_TOTAL_FEE = afterLateTotal;

    setTableData(newData);
  };

  // Preview
  const handleClickPreview = () => {
    const hasEmpty = tableData.some((item) =>
      [
        item.odppM_FEE,
        item.exaM_FEE,
        item.pC_FEE,
        item.m_S_FEE_F_C_T,
        item.miG_FEE,
        item.locaL_LEVY,
        item.misC_FEE,
        item.rE_REG_FEE,
        item.latE_FEE,
      ].some((val) => val === "" || val === null || isNaN(parseFloat(val)))
    );

    if (hasEmpty) {
      Swal.fire(
        "Validation Error",
        "All fields are required and must be numeric.",
        "warning"
      );
      return;
    }

    setLoading(true);
    setTimeout(() => {
      setIsPreviewed(true);
      setLoading(false);
    }, 400);
  };

  // Edit Mode
  const handleClickEdit = () => {
    setLoading(true);
    setTimeout(() => {
      setIsPreviewed(false);
      setLoading(false);
    }, 400);
  };

  // Update API Call
  const handleUpdateClick = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to edit once submitted!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = tableData.map((item) => ({
          autO_CODE: item.autO_CODE,
          odppM_FEE: parseFloat(item.odppM_FEE) || 0,
          exaM_FEE: parseFloat(item.exaM_FEE) || 0,
          pC_FEE: parseFloat(item.pC_FEE) || 0,
          m_S_FEE_F_C_T: parseFloat(item.m_S_FEE_F_C_T) || 0,
          miG_FEE: parseFloat(item.miG_FEE) || 0,
          locaL_LEVY: parseFloat(item.locaL_LEVY) || 0,
          misC_FEE: parseFloat(item.misC_FEE) || 0,
          rE_REG_FEE: parseFloat(item.rE_REG_FEE) || 0,
          beforE_LATE_TOTAL_FEE: parseFloat(item.beforE_LATE_TOTAL_FEE) || 0,
          latE_FEE: parseFloat(item.latE_FEE) || 0,
          afteR_LATE_TOTAL_FEE: parseFloat(item.afteR_LATE_TOTAL_FEE) || 0,
        }));

        try {
          setLoading(true);
          const response = await fetch(
            `${config.API_BASE_URL2}/UpdateFeesDataCl12`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(payload),
            }
          );

          const data = await response.json();

          if (response.ok) {
            Swal.fire(
              "Success",
              "Fees structure updated successfully!",
              "success"
            ).then(async () => {
              await handleDownload();
              await sendEmail();
              await fetchData();
            });
          } else {
            Swal.fire(
              "Error",
              data.message || "Something went wrong.",
              "error"
            );
          }
        } catch (error) {
          console.error("Error updating fees:", error);
          Swal.fire("Error", "Something went wrong while updating.", "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  // PDF Download
  const handleDownload = async () => {
    try {
      const blob = await pdf(
        <FeesStructurePDF12 tableData={tableData} />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Class-XII-Fees-Structure.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      Swal.fire({
        icon: "success",
        title: "Download Complete",
        text: "File has been downloaded successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("PDF download failed:", error);
      Swal.fire("Error", "Something went wrong while downloading", "error");
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-1">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-inr"></i>&nbsp; Class XII Fees Structure
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(
                            "/intermediate-accounts-dashboard-class-xii"
                          );
                        }}
                      >
                        Home&nbsp;
                      </a>
                    </li>
                    <li className="active">Class XII Fees Structure</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row" style={{ padding: "0px" }}>
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    {tableData.length > 0 &&
                      tableData.some(
                        (item) => item.updatE_STATUS === "YES"
                      ) && (
                        <div className="d-flex justify-content-end p-2">
                          <button
                            type="button"
                            className="btn btn-success btn-sm"
                            onClick={handleDownload}
                          >
                            <i className="fa fa-download me-1"></i> Download Pdf
                          </button>
                        </div>
                      )}

                    <div className="table-responsive">
                      <table className="table table-hover table-bordered mb">
                        <thead>
                          <tr className="table-info">
                            <th>#</th>
                            <th>Appearing</th>
                            <th>Caste Cate.</th>
                            <th>Reg Year</th>
                            <th>Category</th>
                            <th>Gender</th>
                            <th>ODPPM Fee</th>
                            <th>Exam Fee</th>
                            <th>PC Fee</th>
                            <th>M/S F.C.T Fee</th>
                            <th>Migration Fee</th>
                            <th>Local Levy</th>
                            <th>Misc Fee</th>
                            <th>Re-Reg Fee</th>
                            <th>Total fees (Before start of late fee)</th>
                            <th>Late Fee</th>
                            <th>Total fees (After start of late fee)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.length > 0 ? (
                            tableData.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td
                                  style={{ fontSize: "8px" }}
                                  ref={(el) => {
                                    if (el)
                                      el.style.setProperty(
                                        "font-size",
                                        "12px",
                                        "important"
                                      );
                                  }}
                                >
                                  {item.appearinG_TYPE || ""}
                                </td>
                                <td
                                  style={{ fontSize: "8px" }}
                                  ref={(el) => {
                                    if (el)
                                      el.style.setProperty(
                                        "font-size",
                                        "12px",
                                        "important"
                                      );
                                  }}
                                >
                                  {item.castE_CATEGORY === "GENERAL"
                                    ? "General & EWS"
                                    : item.castE_CATEGORY === "OTHERS"
                                    ? "SC/ST/BC-1/BC-2"
                                    : ""}
                                </td>
                                <td
                                  style={{ fontSize: "8px" }}
                                  ref={(el) => {
                                    if (el)
                                      el.style.setProperty(
                                        "font-size",
                                        "12px",
                                        "important"
                                      );
                                  }}
                                >
                                  {item.registratioN_YEAR}
                                </td>
                                <td
                                  style={{ fontSize: "8px" }}
                                  ref={(el) => {
                                    if (el)
                                      el.style.setProperty(
                                        "font-size",
                                        "12px",
                                        "important"
                                      );
                                  }}
                                >
                                  {item.category}
                                  {item.attempT_TYPE && (
                                    <p>
                                      
                        {item.attempT_TYPE === "1"
                          ? "(First Attempt)"
                          : item.attempT_TYPE === "GREATER_THAN_1" ? "(Subsequent Attempt)" : ""}
                        
                                    </p>
                                  )}
                                </td>
                                <td
                                  style={{ fontSize: "8px" }}
                                  ref={(el) => {
                                    if (el)
                                      el.style.setProperty(
                                        "font-size",
                                        "12px",
                                        "important"
                                      );
                                  }}
                                >
                                  {item.gender}
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.odppM_FEE}
                                    onChange={(e) =>
                                      handleInputChange(e, "odppM_FEE", index)
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                    style={{ width: "80px" }}
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.exaM_FEE}
                                    onChange={(e) =>
                                      handleInputChange(e, "exaM_FEE", index)
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                    style={{ width: "80px" }}
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.pC_FEE}
                                    onChange={(e) =>
                                      handleInputChange(e, "pC_FEE", index)
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                    style={{ width: "80px" }}
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.m_S_FEE_F_C_T}
                                    onChange={(e) =>
                                      handleInputChange(
                                        e,
                                        "m_S_FEE_F_C_T",
                                        index
                                      )
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                    style={{ width: "80px" }}
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.miG_FEE}
                                    onChange={(e) =>
                                      handleInputChange(e, "miG_FEE", index)
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                    style={{ width: "80px" }}
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.locaL_LEVY}
                                    onChange={(e) =>
                                      handleInputChange(e, "locaL_LEVY", index)
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                    style={{ width: "80px" }}
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.misC_FEE}
                                    onChange={(e) =>
                                      handleInputChange(e, "misC_FEE", index)
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                    style={{ width: "80px" }}
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.rE_REG_FEE}
                                    onChange={(e) =>
                                      handleInputChange(e, "rE_REG_FEE", index)
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                    style={{ width: "80px" }}
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.beforE_LATE_TOTAL_FEE}
                                    disabled
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.latE_FEE}
                                    onChange={(e) =>
                                      handleInputChange(e, "latE_FEE", index)
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                    style={{ width: "80px" }}
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.afteR_LATE_TOTAL_FEE}
                                    disabled
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="17"
                                className="text-center text-muted"
                              >
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>

                        <tfoot>
                          <tr>
                            <th colSpan="17" className="text-end">
                              {tableData.length > 0 ? (
                                tableData.some(
                                  (item) => item.updatE_STATUS === "YES"
                                ) ? (
                                  <p className="text-danger text-center mt-3">
                                    Fees Structure already updated. Changes are
                                    not allowed.
                                  </p>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <marquee className="fomarquee">
                                      Fees Structure can only be updated once.
                                      No further changes will be applicable
                                      after submitting.
                                    </marquee>
                                    {isPreviewed ? (
                                      <>
                                        <button
                                          type="button"
                                          className="btn btn-warning btn-sm ms-2"
                                          onClick={handleClickEdit}
                                        >
                                          <i className="fa fa-edit me-1"></i>{" "}
                                          Edit
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-sm ms-2"
                                          onClick={handleUpdateClick}
                                        >
                                          <i className="fa fa-save"></i>
                                          &nbsp;Submit
                                        </button>
                                      </>
                                    ) : (
                                      <button
                                        type="button"
                                        className="btn btn-info btn-sm ms-2"
                                        onClick={handleClickPreview}
                                      >
                                        <i className="fa fa-eye me-1"></i>{" "}
                                        Preview
                                      </button>
                                    )}
                                  </div>
                                )
                              ) : null}
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default FeesStructure12;
